import * as _4 from 'lodash4';
import { ICourseRequisite } from '../interfaces/course_requisite_interfaces';

export class RequisiteNode implements ICourseRequisite {
  public id: ICourseRequisite['id'];
  public level: ICourseRequisite['level'];
  public type: string;
  public title: ICourseRequisite['title'];
  public test: ICourseRequisite['test'];
  public range: ICourseRequisite['range'];
  public course: ICourseRequisite['course'];
  public is_course_satisfied: ICourseRequisite['is_course_satisfied'];
  public is_grade_satisfied: ICourseRequisite['is_grade_satisfied'];
  public childrens: RequisiteNode[];
  public parent?: RequisiteNode;

  constructor(reqNode: Partial<RequisiteNode>) {
    _4.merge(this, reqNode);
    this.childrens = [];
    this.parent = undefined;
  }
}

export class RequisiteTree {
  public root?: RequisiteNode;
  constructor() {
    this.root = undefined;
  }

  insert(reqNode: Partial<RequisiteNode>) {
    const newNode = new RequisiteNode(reqNode);
    if (this.root === undefined) {
      this.root = newNode;
    } else {
      this.insertData(reqNode, this.root);
    }
  }

  insertData(newNodeData: Partial<RequisiteNode>, node: RequisiteNode): RequisiteNode {
    const newNode = new RequisiteNode(newNodeData);
    if (newNode.level > node.level) {
      const lastChildren = _4.last(node.childrens);
      if (!lastChildren || !lastChildren.level || lastChildren.level === newNode.level) {
        node.childrens.push(newNode);
        newNode.parent = node;
        return newNode;
      } else {
        return this.insertData(newNodeData, lastChildren);
      }
    } else {
      return this.insertData(newNodeData, node.parent as RequisiteNode);
    }
  }
}



// WEBPACK FOOTER //
// ./app/vendor/biz-ng-requisite-tree/src/servants/course_requirement_tree.ts